import * as React from 'react'
import { Button, Form } from 'react-bootstrap'

// クライアントログインフォームのパラメータ
const loginClientPrams = {
  action: `https://client.afi-b.com/client/b/cl/main`,
  loginNameParam: `login_name`,
  passwordNameParam: `password`,
  hiddenPrams: {
    name: `login_division`,
    value: `client`,
  },
}

// markup
const GlobalHeaderLoginFormClient = (): React.JSX.Element => {
  return (
    <>
      <Form
        action={loginClientPrams.action}
        method="post"
        data-e2e-test="loginFormClient"
        data-testid="loginFormClient"
      >
        <div className="row m-0">
          <small className="p-0 m-0 fw-bold">クライアント会員</small>
          <div className="col-md p-0">
            <Form.Group controlId="formClientId">
              <Form.Control
                type="text"
                name={loginClientPrams.loginNameParam}
                placeholder="クライアントID"
                data-e2e-test="formClientId"
              />
            </Form.Group>
          </div>

          <div className="col-md p-0 globalHeader-mediaQuery-ml-1">
            <Form.Group controlId="formClientPassword">
              <Form.Control
                type="password"
                name={loginClientPrams.passwordNameParam}
                placeholder="パスワード"
                data-e2e-test="formClientPassword"
                autoComplete="true"
              />
            </Form.Group>
          </div>

          <div className="col-md p-0 globalHeader-mediaQuery-ml-1">
            <Form.Control
              type="hidden"
              name={loginClientPrams.hiddenPrams.name}
              value={loginClientPrams.hiddenPrams.value}
            />
            <Button
              variant="client"
              type="submit"
              className="globalHeader__loginButton w-100"
              data-e2e-test="formClientSubmit"
            >
              ログイン
            </Button>
          </div>
        </div>

        <div className="textLink">
          <a className="textLink__link" href="/general/client/reminder/">
            パスワードを忘れた方はこちら
          </a>
        </div>
      </Form>
    </>
  )
}

export default GlobalHeaderLoginFormClient
